<template>
	<!-- <div class="popup-modal"> -->
		<button-tertiary
		icon="close"
		buttonStyle="round"
		@clicked="emit('closePopUps')"/>
		<img
		v-if="popUpInfo.iconUrl && showImg"
		class="mdw-img-link"
		alt="Modal Image"
		:src="popUpInfo.iconUrl"
		@error="showImg = false">
		<!-- PopUp Title -->
		<div v-if="popUpInfo.title" class="title" :class="{ 'no-icon': !(popUpInfo.iconUrl && showImg) }">
			{{popUpInfo.title}}
		</div>
		<!-- PopUp Description -->
		<div v-if="popUpInfo.description" class="description">
			{{popUpInfo.description}}
		</div>
		<!-- Functionality Button -->
		<button-primary
		v-if="popUpInfo.buttonLabel || popUpInfo.menuItem || popUpInfo.link"
        buttonSize="medium"
		buttonType="secondary"
		iconPosition="right"
		:icon="popUpInfo.menuItem || popUpInfo.link ? 'arrow-right-full' : 'check-line'"
		:label="popUpInfo.buttonLabel"
		@clicked="handleClick"/>
		<!-- Terms checkbox -->
		<selector-checkbox
		v-if="popUpInfo.dispensable"
		id="termsAndConditions"
		:label="t('modals.dismissText')"
		:selected="dismiss"
		@clicked="dismiss = !dismiss"/>
	<!-- </div> -->
</template>

<script setup>
import ButtonPrimary from '@/components/generic/buttons/Primary'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
import SelectorCheckbox from '@/components/generic/selectors/checkbox/Checkbox'

/* Vue &&  Helpers */
import { ref, watch } from 'vue'
import { navigateByPath } from '@/router/helpers/navigation'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['addDismissArray', 'removeDismissArray', 'closePopUps'])

/* Props
@popUpInfo {Object} - PopUp Info
*/
const props = defineProps({
	popUpInfo: Object
})

/*************************************************
*                                                *
*                     Aux Data                   *
*                                                *
*************************************************/
const dismiss = ref(false)
const showImg = ref(true)

watch(() => dismiss.value, () => {
    dismiss.value ? emit('addDismissArray', props.popUpInfo.id) : emit('removeDismissArray', props.popUpInfo.id)
})

const handleClick = () => {
	if (props.popUpInfo.menuItem) {
		navigateByPath(props.popUpInfo.menuItem.link)
	} else if (props.popUpInfo.link) {
		window.open(props.popUpInfo.link, '_blank')
	}

	emit('closePopUps')
}

</script>

<style lang="scss" scoped>
.tertiary-button-wrapper{
    position: absolute;
    right: 24px;

    width: 40px;
    height: 40px;
}

.mdw-img-link {
    width: 88px;
    height: 88px;
}

.title {
    margin: 16px 0 8px 0;

    @include H3-Medium;
    line-height: 28px;
    color: var(--primary);
    word-wrap: break-word;

	&.no-icon {
		margin-top: 42px;
	}
}

.description {
    @include H6-Regular;
    line-height: 18px;
    color: var(--secondary-dark-2);
}

.button-primary {
    width: 100%;
    height: 48px;
    margin: 24px 0;
}
</style>
